import React from 'react'

import {
  Item
} from './styles'

export function SelectedItem({ children }) {
  return <Item> { children } </Item>
}
